<template>
  <div class="email-template-edit-overlay relative w-full"
       @mouseenter="onMouseEnter"
       @mouseleave="onMouseLeave"
       @click.stop
  >
    <div class="email-template-edit-overlay__content"
         :class="{
           'email-template-section-dimmed': isDimmed,
           'email-template-edit-overlay__content--active': isActive
         }"
    >
      <slot />
    </div>

    <div v-if="isActive"
         class="email-template-edit-overlay__actions absolute inset-0 z-10 flex items-center justify-center"
    >
      <base-button variant="primary-compact"
                   :router-link="emailTemplateRoute"
                   class="email-template-edit-overlay__button gap-1.5 shadow-btn-primary flex items-center"
                   @click.stop
      >
        <edit-icon class="h-3 w-3 shrink-0" />
        <span>{{ label }}</span>
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/base-components/BaseButton.vue'
import EditIcon from '@/assets/images/icons/EditIcon'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'EmailTemplateEditOverlay',

  components: { BaseButton, EditIcon },

  props: {
    label: {
      type: String,
      required: true
    },
    section: {
      type: String,
      required: true
    },
    activeSection: {
      type: String,
      default: null
    }
  },

  computed: {
    isActive() {
      return this.activeSection === this.section
    },

    isDimmed() {
      return this.activeSection !== null && this.activeSection !== this.section
    },

    emailTemplateRoute() {
      return {
        name: ROUTE_NAMES.emailTemplate,
        params: { botId: this.$route.params.botId }
      }
    }
  },

  methods: {
    onMouseEnter() {
      this.$emit('activate', this.section)
    },

    onMouseLeave() {
      this.$emit('deactivate', this.section)
    }
  }
}
</script>

<style scoped lang="scss">
.email-template-edit-overlay__content {
  @apply text-gray-table;
  transition: opacity 0.2s ease-in-out, color 0.2s ease-in-out;
}

.email-template-edit-overlay__content--active {
  @apply text-gray-dark;

  ::v-deep p,
  ::v-deep span,
  ::v-deep div {
    color: inherit;
  }
}

.email-template-edit-overlay__actions {
  background: rgba(255, 255, 255, 0.55);
}

.email-template-edit-overlay__button {
  color: #ffffff !important;

  ::v-deep span {
    color: #ffffff !important;
  }

  ::v-deep svg {
    color: #ffffff !important;
    fill: currentColor;
  }
}
</style>

<style lang="scss">
.email-template-section-dimmed {
  opacity: 0.4;
  transition: opacity 0.2s ease-in-out;
}
</style>
